#app = angular.module("seismology", ['ngMaterial','ui.router','firebase', 'ngSanitize'])
app = angular.module("seismology", ['ngMaterial','ui.router','firebase', 'ngSanitize','720kb.socialshare', 'ngFileUpload', 'angular-timeline', 'angulartics', 'angulartics.google.analytics', 'ngCookies', 'pascalprecht.translate'])

 
app.constant "CLOUDINARY_CONFIGS",
  UPLOAD_PRESET: 'k3zqtmgp'
  UPLOAD_URL: 'https://api.cloudinary.com/v1_1/doyeq9idz/image/upload'
  IMAGE_BASE_URL: 'https://res-4.cloudinary.com/doyeq9idz/image/upload'

app.constant 'VAPID_PUBLIC_KEY',
  STRING: 'BCl283ur-v-hemp5ikrzX3w3n9Jg2ywjEtf-a2x19fchhizC6Plby5gBde7YGW4Vz9oS_poxW7IGhTTWoFfyHZs='
  ARRAY: new Uint8Array([4, 41, 118, 243, 123, 171, 250, 255, 161, 122, 106, 121, 138, 74, 243, 95, 124, 55, 159, 210, 96, 219, 44, 35, 18, 215, 254, 107, 108, 117, 245, 247, 33, 134, 44, 194, 232, 249, 91, 203, 152, 1, 117, 238, 216, 25, 110, 21, 207, 218, 18, 254, 154, 49, 91, 178, 6, 133, 52, 214, 160, 87, 242, 29, 155])

app.config ($mdThemingProvider, $mdIconProvider, $translateProvider)->

  

  $mdIconProvider 
    .defaultIconSet("./assets/svg/avatars.svg", 128)
    .icon("menu"       , "./assets/svg/menu.svg"        , 24)
    .icon("share"      , "./assets/svg/share.svg"       , 24)
    .icon("google_plus", "./assets/svg/google_plus.svg" , 512)
    .icon("hangouts"   , "./assets/svg/hangouts.svg"    , 512)
    .icon("twitter"    , "./assets/svg/twitter.svg"     , 512)
    .icon("phone"      , "./assets/svg/phone.svg"       , 512);

  $mdThemingProvider.theme('default')
    .primaryPalette('blue')
    .accentPalette('red');

  $translateProvider.useStaticFilesLoader
    prefix: 'assets/i18n/locale-',
    suffix: '.json'


  $translateProvider.registerAvailableLanguageKeys(['en', 'ja'], {
    'en_*': 'en',
    'ja_*': 'ja'
  })
  $translateProvider.preferredLanguage('en')
  $translateProvider.fallbackLanguage('ja')
  $translateProvider.useLocalStorage()
  $translateProvider.useSanitizeValueStrategy(null)


app.run ($rootScope, $state, $location) ->
  $rootScope.$on "$stateChangeError", (event, toState, toParams, fromState, fromParams, error)->
    if error is "AUTH_REQUIRED"
      location = $location.path()
      $state.go('signin', redirect: location)
      

app.config ($stateProvider, $urlRouterProvider) ->
  $stateProvider.state 'dashboard',
    url: '/dashboard'
    abstract: true
    controller: 'DashboardCtrl'
    templateUrl: 'templates/dashboard.html'
    resolve:
      currentAuth: ($firebaseAuth) ->
        $firebaseAuth().$requireSignIn()
  $stateProvider.state 'dashboard.introduction',
    url: '/introduction'
    controller: 'IntroCtrl'
    templateUrl: 'templates/introduction.html'
  $stateProvider.state 'dashboard.home',
    url: ''
    controller: 'HomeCtrl'
    templateUrl: 'templates/home.html'
  $stateProvider.state 'dashboard.guideline',
    url: '/guideline'
    controller: 'GuidelineCtrl'
    templateUrl: 'templates/guideline.html'
  $stateProvider.state 'dashboard.credit',
    url: '/credit'
    controller: 'CreditCtrl'
    templateUrl: 'templates/credit.html'
  $stateProvider.state 'dashboard.entries',
    url: '/entries/:stage'
    controller: 'EntriesCtrl'
    templateUrl: 'templates/entries.html'
  $stateProvider.state 'dashboard.profile',
    url: '/profile'
    controller: 'ProfileCtrl'
    templateUrl: 'templates/profile.html'
  $stateProvider.state 'dashboard.learn',
    url: '/learn'
    controller: 'LearnCtrl'
    templateUrl: 'templates/kula/learn.html'
  $stateProvider.state 'dashboard.lesson',
    url: '/lesson/:id'
    controller: 'LessonCtrl'
    templateUrl: 'templates/kula/lesson.html'    
  $stateProvider.state 'dashboard.lesson.char',
    url: '/:char_id'
    controller: 'CharCtrl'
    templateUrl: 'templates/kula/char.html'    
  $stateProvider.state 'dashboard.connect',
    url: '/connect'
    controller: 'ConnectCtrl'
    templateUrl: 'templates/connect.html'
  $stateProvider.state 'dashboard.post',
    url: '/post/:post_id'
    controller: 'PostCtrl'
    templateUrl: 'templates/post-single.html'
    resolve:
      post: ($stateParams, PostFactory) ->
        PostFactory.get($stateParams.post_id).$loaded()
  $stateProvider.state 'dashboard.connect.timeline',
    url: '/'
    controller: 'ConnectCtrl'
    templateUrl: 'templates/connect.html'
  $stateProvider.state 'dashboard.editing',
    url: '/editing'
    controller: 'EditingListCtrl'
    templateUrl: 'templates/editing_list.html'
  $stateProvider.state 'dashboard.personal',
    url: '/personal'
    controller: 'PersonalCtrl'
    templateUrl: 'templates/personal.html'
  $stateProvider.state 'dashboard.personal.fav-list',
    url: '/fav-list'
    controller: 'FavListCtrl'
    templateUrl: 'templates/partial/fav-list.html'
  $stateProvider.state 'dashboard.personal.history',
    url: '/history'
    controller: 'PersonalHistoryCtrl'
    templateUrl: 'templates/partial/history.html'
  $stateProvider.state 'signin',      
    url: '/sign_in?redirect'
    controller: 'SignInCtrl as signin'
    templateUrl: 'templates/sign_in.html'
  $stateProvider.state 'dashboard.quakes',
    url: '/quakes'
    controller: 'QuakesCtrl'
    templateUrl: 'templates/quakes.html'
  $stateProvider.state 'dashboard.forum',
    url: '/forum'
    controller: 'ForumCtrl'
    templateUrl: 'templates/forum.html'
  $stateProvider.state 'dashboard.discussion',
    url: '/discussion/:id'
    controller: 'DiscussionCtrl'
    templateUrl: 'templates/discussion.html'
    resolve:
      discussion: ($stateParams, DiscussionFactory)->
        DiscussionFactory.get($stateParams.id).$loaded()
  $stateProvider.state 'transcription',      
    url: '/transcription/:id?:ref'
    abstract: true
    templateUrl: 'templates/transcription.html'
    controller: 'TranscriptionCtrl'
    resolve:
      currentAuth: ($firebaseAuth) ->
        $firebaseAuth().$requireSignIn()
      book: ($stateParams, Books)->
        Books.get($stateParams.id)
      transcriptionList: ($stateParams, Transcription) ->
        Transcription.getList($stateParams.id)
  $stateProvider.state 'transcription.content',
    url: '/:content'
    views:
      content: 
        templateUrl: 'templates/transcription/content.html'
        controller: 'TranscriptionContentCtrl'
      content_status:
        templateUrl: 'templates/transcription/content_status.html'
        controller: 'TranscriptionContentStatusCtrl'
      action_buttons:
        templateUrl: 'templates/transcription/action_buttons.html'
        controller: 'TranscriptionActionButtonsCtrl'        
    resolve:
      transcription: ($stateParams, Transcription)->
        Transcription.get($stateParams.id, parseInt($stateParams.content)-1)
  $stateProvider.state 'transcription.content.view',
    url: '/view'
    controller: 'TranscriptionEditorCtrl'
    templateUrl: 'templates/transcription/view.html'
  $stateProvider.state 'transcription.content.input',
    url: '/input'
    controller: 'TranscriptionInputCtrl'
    templateUrl: 'templates/transcription/input.html'
  $stateProvider.state 'transcription.content.notes',
    url: '/notes'
    controller: 'TranscriptionNotesCtrl'
    templateUrl: 'templates/transcription/notes.html'
  $stateProvider.state 'transcription.content.history',
    url: '/history'
    templateUrl: 'templates/transcription/history.html'
    controller: 'TranscriptionHistoryCtrl'
  $stateProvider.state 'transcription.content.legends',
    url: '/legends'
    controller: 'TranscriptionEditorCtrl'
    templateUrl: 'templates/transcription/legends.html'
      
  $urlRouterProvider.otherwise "/dashboard"
    



// WEBPACK FOOTER //
// ./app/app.coffee